(function () {
    'use strict';

    angular.module('imnApp').controller('AlarmShowController', AlarmShowController);

    AlarmShowController.$inject = ['$scope', '$interval', '$uibModalInstance', 'OltData', 'AlarmShowService'];

    function AlarmShowController($scope, $interval, $uibModalInstance, OltData, AlarmShowService) {
        var vm = this;
        var timer = null;
        
        vm.close = close;
        vm.isOlt8820G = isOlt8820G;
        vm.isOlt8820i = isOlt8820i;

        initialize();

        function initialize() {
            $interval.cancel(timer);
            vm.oltSelecionada = OltData.detail;
            obterAlarmShowDaOlt();
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function obterAlarmShowDaOlt() {
            if (vm.oltSelecionada)
                AlarmShowService.getAlarmShow(vm.oltSelecionada).then(carregaDadosDaApi);
            else
                close();
        }

        function carregaDadosDaApi(data) {
            vm.alarmShow8820G = data.alarmShow8820G;
            vm.alarmShow8820i = data.alarmShow8820i;
        }

        function isOlt8820G() {
            return OltData.detail.model !== 'Intelbras8820i';
        }

        function isOlt8820i() {
            return OltData.detail.model === 'Intelbras8820i';
        }

    }
})();
